import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showMemberLoader,
    onSaveMember,
    onMemberClose,
} from 'actions/member';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const MemberEdit = () => {
    const dispatch = useDispatch();
    const editMemberState = useSelector(state => state.members.editMemberState);
    const member = useSelector(state => state.members.selectedMember);
    const [selectedMember, setSelectedMember] = useState(member);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes
    useEffect(() => {
        setSelectedMember(member);
        setFormValid(false);
        validateForm();
    }, [member]);

    // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedMember]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedMemberField(name, value);
        validateField(name, value);
    };

    const updateSelectedMemberField = (fieldName, value) => {
        const newMember = { ...member };
        newMember[fieldName] = value;
        setSelectedMember(newMember);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedMember));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showMemberLoader());
                dispatch(onMemberClose());
                dispatch(onSaveMember(selectedMember));
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onMemberClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedMember)}
                        {showErrors(formErrors)}
                        {inputFields(member, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={editMemberState}>
            {modalHeader(<IntlMessages id="member.saveMember" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="member.saveMember" />)}
        </Modal>
    );
};

export default MemberEdit;


// WEBPACK FOOTER //
// ./components/Agile/member/memberMaintenance/memberEdit/index.js